import client from './client';
import { Item } from '../types/entities';
import { ApiResponse, CreateItemRequest } from '../types/api';

export const itemAPI = {
  getAll: async (): Promise<Item[]> => {
    const response = await client.get('/items');
    return response.data.data;
  },

  getById: async (id: number): Promise<Item> => {
    const response = await client.get(`/items/${id}`);
    return response.data.data;
  },

  search: async (query: string): Promise<Item[]> => {
    const response = await client.get('/items/search', { params: { q: query } });
    return response.data.data;
  },

  create: async (data: CreateItemRequest): Promise<Item> => {
    const response = await client.post('/items', data);
    return response.data.data;
  },

  update: async (id: number, data: Partial<CreateItemRequest>): Promise<Item> => {
    const response = await client.put(`/items/${id}`, data);
    return response.data.data;
  },

  delete: async (id: number): Promise<ApiResponse<null>> => {
    const response = await client.delete(`/items/${id}`);
    return response.data;
  },
};
